(function () {
    var $body = $('body');

    var scrollo = {
        init: function () {
            scrollo.control();
        },
        offset: function (el) {
            var rect = el.getBoundingClientRect();
            var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            return {
                top: rect.top + scrollTop,
                left: rect.left + scrollLeft,
            };
        },
        adjustAnchor: function (e) {
            e.preventDefault();
            const $anchor = $(':target');
            const fixedElementsHeight = scrollo.get.fixedpageElementsHeight();

            if ($anchor.length > 0) {
                e.stopPropagation();
                // When we prevent default, we have to also change focus to target manually
                $anchor.eq(0).focus();
                window.scrollTo(0, scrollo.offset($anchor.get(0)).top - fixedElementsHeight);
            }
        },
        control: function () {
            $(window).on('hashchange load', scrollo.adjustAnchor);
            /**
             * checks for any <a> tag that has the hash-tag prefix and execute the adjustAnchor function
             * the .content a[href^="#"] was added to support the publication content <a> tags
             */
            $body.on(
                'click',
                'a.table-fn[href^="#"], a.ref.fn[href^="#"], .scroll-to-target a[href^="#"], .content a[href^="#"]',
                function (e) {
                    if (window.location.hash === $(this).attr('href')) {
                        scrollo.adjustAnchor(e);
                    }
                }
            );
            $body.on('click keydown', 'a[href^="#"].sr-only-focusable', function (e) {
                // pass click and ENTER to action
                if (e.keyCode && e.keyCode !== 13) {
                    return;
                }
                if (window.location.hash === $(this).attr('href')) {
                    scrollo.adjustAnchor(e);
                }
            });
            $body.on('click', '.w-slide__back', function () {
                if ($('[data-scroll-back-to]').length) {
                    $(document).scrollTop($('[data-scroll-back-to]').data('scroll-back-to'));
                    $('[data-scroll-back-to]').removeAttr('data-scroll-back-to');
                }
            });
        },

        get: {
            fixedpageElementsHeight: function () {
                var elementsHeight = 0;

                var $fixedHeader = $('header.fixed, .pageHeader');
                if ($fixedHeader.length) {
                    elementsHeight = $fixedHeader.outerHeight();
                }

                const $scrolloThenFix = $('.scrollThenFix');
                if ($scrolloThenFix.length) {
                    elementsHeight = $scrolloThenFix.outerHeight();
                }

                const $stickyCoolbar = $('.coolBar.stickybar--sticky');
                let stickyCoolbarHeigh = 0;
                if ($stickyCoolbar.length) {
                    stickyCoolbarHeigh = $stickyCoolbar.outerHeight();
                    if (stickyCoolbarHeigh === 0) {
                        stickyCoolbarHeigh = $stickyCoolbar.find('.stickybar__wrapper').outerHeight();
                    }
                    elementsHeight += stickyCoolbarHeigh;
                }

                if ($('header .scrollThenFix, .coolBar').length) {
                    $.each($('header .scrollThenFix, .coolBar'), function (index, value) {
                        if ($(value).outerHeight()) {
                            elementsHeight += $(value).outerHeight();
                        }
                    });
                }

                return elementsHeight;
            },
        },
    };

    UX.scrollo = scrollo; // add to global namespace
})();
